module.exports = __webpack_public_path__ + "img/drone_06_H.32fd3012.webp";